import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  FormLayout,
  Card,
  TextField,
  Select,
  InlineError,
  PageActions,
  Toast,
  Loading,
  Button,
  Collapsible,
  Text,
  Checkbox,
  Modal,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { validate } from "email-validator";

const AddEditUser = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSaving, setIsSaving] = useState(
    props.type === "edit" ? true : false,
  );
  const [item, setItem] = useState({
    firstName: "",
    lastName: "",
    password: "",
    confirmPassword: "",
    email: "",
    role: "",
    edit_news: true,
    edit_classes: true,
    edit_sessions: true,
    edit_users: true,
    edit_instructors: true,
    edit_reviews: true,
    edit_packages: true,
    edit_memberships: true,
    view_reports: true,
    view_news: true,
    view_classes: true,
    view_sessions: true,
    view_users: true,
    view_instructors: true,
    view_reviews: true,
    view_packages: true,
    view_memberships: true,
  });
  const optionsRoles = [{ label: "Super Admin", value: "1" }];
  const handleChangeFirstName = (newValue) => {
    setItem({ ...item, firstName: newValue });
    setFirstNameError("");
  };
  const handleChangeLastName = (newValue) => {
    setItem({ ...item, lastName: newValue });
    setLastNameError("");
  };
  const handleChangeEmail = (newValue) => {
    setItem({ ...item, email: newValue });
    setEmailError("");
  };
  const handleChangePassword = (newValue) => {
    setItem({ ...item, password: newValue });
    setPasswordError("");
    setPasswordsError("");
  };
  const handleChangeConfirmPassword = (newValue) => {
    setItem({ ...item, confirmPassword: newValue });
    setConfirmPasswordError("");
    setPasswordsError("");
  };
  const handleChangeRole = (newValue) => {
    setItem({ ...item, role: newValue });
    setRoleError("");
  };
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [passwordsError, setPasswordsError] = useState("");
  const [roleError, setRoleError] = useState("");
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;

  useEffect(() => {
    // console.log("id===", parseInt(id) === 1);
    props.type === "edit" &&
      axios
        .get(`/management/users/${id}`)
        .then((result) => {
          setItem({
            firstName: result?.data?.data?.first_name
              ? result.data.data.first_name
              : "",
            lastName: result?.data?.data?.last_name
              ? result.data.data.last_name
              : "",
            email: result?.data?.data?.email ? result.data.data.email : "",
            edit_news:
              result?.data?.data?.permission_names &&
              result?.data?.data?.permission_names.length &&
              result?.data?.data?.permission_names.includes("edit news")
                ? true
                : false,
            edit_classes:
              result?.data?.data?.permission_names &&
              result?.data?.data?.permission_names.length &&
              result?.data?.data?.permission_names.includes("edit classes")
                ? true
                : false,
            edit_sessions:
              result?.data?.data?.permission_names &&
              result?.data?.data?.permission_names.length &&
              result?.data?.data?.permission_names.includes("edit sessions")
                ? true
                : false,
            edit_users:
              result?.data?.data?.permission_names &&
              result?.data?.data?.permission_names.length &&
              result?.data?.data?.permission_names.includes("edit users")
                ? true
                : false,
            edit_instructors:
              result?.data?.data?.permission_names &&
              result?.data?.data?.permission_names.length &&
              result?.data?.data?.permission_names.includes("edit instructors")
                ? true
                : false,
            edit_reviews:
              result?.data?.data?.permission_names &&
              result?.data?.data?.permission_names.length &&
              result?.data?.data?.permission_names.includes("edit reviews")
                ? true
                : false,
            edit_packages:
              result?.data?.data?.permission_names &&
              result?.data?.data?.permission_names.length &&
              result?.data?.data?.permission_names.includes("edit packages")
                ? true
                : false,
            edit_memberships:
              result?.data?.data?.permission_names &&
              result?.data?.data?.permission_names.length &&
              result?.data?.data?.permission_names.includes("edit memberships")
                ? true
                : false,
            view_reports:
              result?.data?.data?.permission_names &&
              result?.data?.data?.permission_names.length &&
              result?.data?.data?.permission_names.includes("view reports")
                ? true
                : false,
            view_news:
              result?.data?.data?.permission_names &&
              result?.data?.data?.permission_names.length &&
              result?.data?.data?.permission_names.includes("view news")
                ? true
                : false,
            view_classes:
              result?.data?.data?.permission_names &&
              result?.data?.data?.permission_names.length &&
              result?.data?.data?.permission_names.includes("view classes")
                ? true
                : false,
            view_sessions:
              result?.data?.data?.permission_names &&
              result?.data?.data?.permission_names.length &&
              result?.data?.data?.permission_names.includes("view sessions")
                ? true
                : false,
            view_users:
              result?.data?.data?.permission_names &&
              result?.data?.data?.permission_names.length &&
              result?.data?.data?.permission_names.includes("view users")
                ? true
                : false,
            view_instructors:
              result?.data?.data?.permission_names &&
              result?.data?.data?.permission_names.length &&
              result?.data?.data?.permission_names.includes("view instructors")
                ? true
                : false,
            view_reviews:
              result?.data?.data?.permission_names &&
              result?.data?.data?.permission_names.length &&
              result?.data?.data?.permission_names.includes("view reviews")
                ? true
                : false,
            view_packages:
              result?.data?.data?.permission_names &&
              result?.data?.data?.permission_names.length &&
              result?.data?.data?.permission_names.includes("view packages")
                ? true
                : false,
            view_memberships:
              result?.data?.data?.permission_names &&
              result?.data?.data?.permission_names.length &&
              result?.data?.data?.permission_names.includes("view memberships")
                ? true
                : false,
          });
          setIsSaving(false);
        })

        .catch((err) => console.log(err));
  }, []);
  const [open, setOpen] = useState(false);
  const handleToggle = useCallback(() => setOpen((open) => !open), []);
  const handleChange = (key) => {
    setItem((prevItem) => ({
      ...prevItem,
      [key]: !prevItem[key],
    }));
  };
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`/management/users/${id}`)
      .then((result) => {
        navigate("/admin/settings/users-and-permissions");
      })
      .catch((err) => console.log(err));
  };
  const [generalError, setGeneralError] = useState("");
  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} User`}
      backAction={{
        onAction: () => navigate("/admin/settings/users-and-permissions"),
      }}
      narrowWidth
    >
      {isSaving ? <Loading /> : null}

      <Card>
        <FormLayout>
          <FormLayout.Group>
            <TextField
              label="First Name"
              value={item.firstName}
              onChange={handleChangeFirstName}
              error={firstNameError}
            />

            <TextField
              value={item.lastName}
              onChange={handleChangeLastName}
              error={lastNameError}
              label="Last Name"
            />
          </FormLayout.Group>
          <TextField
            value={item.email}
            onChange={handleChangeEmail}
            error={emailError}
            label="Email"
          />
          {props.type === "add" ? (
            <FormLayout.Group>
              <TextField
                value={item.password}
                onChange={handleChangePassword}
                error={passwordError}
                label="Password"
              />
              <TextField
                value={item.confirmPassword}
                onChange={handleChangeConfirmPassword}
                error={confirmPasswordError}
                label="Confirm Password"
              />
            </FormLayout.Group>
          ) : (
            <FormLayout>
              <Button
                onClick={handleToggle}
                ariaExpanded={open}
                ariaControls="basic-collapsible"
                variant="primary"
              >
                Change Password
              </Button>
              <Collapsible
                open={open}
                id="basic-collapsible"
                transition={{
                  duration: "500ms",
                  timingFunction: "ease-in-out",
                }}
                expandOnPrint
              >
                <FormLayout.Group>
                  <TextField
                    value={item.password}
                    onChange={handleChangePassword}
                    error={passwordError}
                    label="Password"
                  />
                  <TextField
                    value={item.confirmPassword}
                    onChange={handleChangeConfirmPassword}
                    error={confirmPasswordError}
                    label="Confirm Password"
                  />
                </FormLayout.Group>
              </Collapsible>
            </FormLayout>
          )}
          <InlineError message={passwordsError} />
          <Text>PERMISSIONS</Text>
          <FormLayout.Group>
            <Checkbox
              label="Edit News"
              checked={item.edit_news}
              onChange={() => handleChange("edit_news")}
            />
            <Checkbox
              label="Edit Classes"
              checked={item.edit_classes}
              onChange={() => handleChange("edit_classes")}
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <Checkbox
              label="Edit Sessions"
              checked={item.edit_sessions}
              onChange={() => handleChange("edit_sessions")}
            />
            <Checkbox
              label="Edit Users"
              checked={item.edit_users}
              onChange={() => handleChange("edit_users")}
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <Checkbox
              label="Edit Instructors"
              checked={item.edit_instructors}
              onChange={() => handleChange("edit_instructors")}
            />
            <Checkbox
              label="Edit Reviews"
              checked={item.edit_reviews}
              onChange={() => handleChange("edit_reviews")}
            />
          </FormLayout.Group>

          <FormLayout.Group>
            <Checkbox
              label="Edit Packages"
              checked={item.edit_packages}
              onChange={() => handleChange("edit_packages")}
            />
            <Checkbox
              label="Edit Memberships"
              checked={item.edit_memberships}
              onChange={() => handleChange("edit_memberships")}
            />
          </FormLayout.Group>

          <FormLayout.Group>
            <Checkbox
              label="View Reports"
              checked={item.view_reports}
              onChange={() => handleChange("view_reports")}
            />
            <Checkbox
              label="View News"
              checked={item.view_news}
              onChange={() => handleChange("view_news")}
            />
          </FormLayout.Group>

          <FormLayout.Group>
            <Checkbox
              label="View Classes"
              checked={item.view_classes}
              onChange={() => handleChange("view_classes")}
            />
            <Checkbox
              label="View Sessions"
              checked={item.view_sessions}
              onChange={() => handleChange("view_sessions")}
            />
          </FormLayout.Group>

          <FormLayout.Group>
            <Checkbox
              label="View Users"
              checked={item.view_users}
              onChange={() => handleChange("view_users")}
            />
            <Checkbox
              label="View Instructors"
              checked={item.view_instructors}
              onChange={() => handleChange("view_instructors")}
            />
          </FormLayout.Group>

          <FormLayout.Group>
            <Checkbox
              label="View Reviews"
              checked={item.view_reviews}
              onChange={() => handleChange("view_reviews")}
            />
            <Checkbox
              label="View Packages"
              checked={item.view_packages}
              onChange={() => handleChange("view_packages")}
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <Checkbox
              label="View Memberships"
              checked={item.view_memberships}
              onChange={() => handleChange("view_memberships")}
            />
          </FormLayout.Group>
          <InlineError message={generalError} />
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" &&
          parseInt(id) !== 1 && (
            <Button
              variant="primary"
              loading={isSaving}
              tone="critical"
              onClick={() => setActiveDelete(true)}
            >
              Delete
            </Button>
          )
        }
      />
      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Item"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <Text>
            <p>Are you sure you want to delete this item?</p>
          </Text>
        </Modal.Section>
      </Modal>
      {toastMarkup}
    </Page>
  );
  function handleSave() {
    let permissions = [];
    item.edit_news && permissions.push("edit news");
    item.edit_classes && permissions.push("edit classes");
    item.edit_sessions && permissions.push("edit sessions");
    item.edit_users && permissions.push("edit users");
    item.edit_instructors && permissions.push("edit instructors");
    item.edit_reviews && permissions.push("edit reviews");
    item.edit_packages && permissions.push("edit packages");
    item.edit_memberships && permissions.push("edit memberships");
    item.view_reports && permissions.push("view reports");
    item.view_news && permissions.push("view news");
    item.view_classes && permissions.push("view classes");
    item.view_sessions && permissions.push("view sessions");
    item.view_users && permissions.push("view users");
    item.view_instructors && permissions.push("view instructors");
    item.view_reviews && permissions.push("view reviews");
    item.view_packages && permissions.push("view packages");
    item.view_memberships && permissions.push("view memberships");
    if (
      !item.firstName ||
      !item.lastName ||
      !item.email ||
      (props.type === "add" && !item.password) ||
      (props.type === "add" && !item.confirmPassword) ||
      // item.role === "" ||
      (item.email && !validate(item.email.replace(/\s/g, ""))) ||
      (props.type === "add" &&
        item.password &&
        item.confirmPassword &&
        item.password !== item.confirmPassword) ||
      (props.type === "add" && item.password.length < 6 && item.password)
    ) {
      !item.firstName && setFirstNameError("This field is required");
      !item.lastName && setLastNameError("This field is required");
      !item.email && setEmailError("This field is required");
      props.type === "add" &&
        !item.password &&
        setPasswordError("This field is required");
      props.type === "add" &&
        !item.confirmPassword &&
        setConfirmPasswordError("This field is required");
      // item.role === "" && setRoleError("Please select a role");
      item.email &&
        !validate(item.email.replace(/\s/g, "")) &&
        setEmailError("Please use a valid email address");
      props.type === "add" &&
        item.password &&
        item.confirmPassword &&
        item.password !== item.confirmPassword &&
        setPasswordsError("Passwords do not match");
      props.type === "add" &&
        item.password.length < 6 &&
        item.password &&
        setPasswordsError("Passwords must be at least 6 characters");
    } else {
      setIsSaving(true);
      const bodyObj = {
        first_name: item.firstName,
        last_name: item.lastName,
        email: item.email,
        is_active: 1,
        password: item.password,
        "confirm-password": item.confirmPassword,
        permissions: permissions,
      };
      props.type === "add"
        ? axios
            .post(`/management/users`, bodyObj)
            .then((result) => {
              navigate("/admin/settings/users-and-permissions");
            })
            .catch((error) => {
              // Error
              console.log("error=", error);
              setIsSaving(false);
              if (error.response) {
                error.response.data.errors.password
                  ? setPasswordError(
                      <ul>
                        {error.response.data.errors.password.map(
                          (element, index) => {
                            return (
                              <div key={index}>
                                <h2>{element}</h2>
                              </div>
                            );
                          },
                        )}
                      </ul>,
                    )
                  : setGeneralError(error.response.data.errors.email);
              } else if (error.request) {
                console.log(error.request);
              } else {
                console.log("Error", error.message);
              }
              console.log(error.config);
            })
        : axios
            .patch(`/management/users/${id}`, bodyObj)
            .then((result) => {
              toggleActive();
              setIsSaving(false);
            })
            .catch((error) => {
              // Error
              console.log("error=", error);
              setIsSaving(false);
              if (error.response) {
                error.response.data.errors.password
                  ? setPasswordError(
                      <ul>
                        {error.response.data.errors.password.map(
                          (element, index) => {
                            return (
                              <div key={index}>
                                <h2>{element}</h2>
                              </div>
                            );
                          },
                        )}
                      </ul>,
                    )
                  : setGeneralError(error.response.data.errors.email);
              } else if (error.request) {
                console.log(error.request);
              } else {
                console.log("Error", error.message);
              }
              console.log(error.config);
            });
    }
  }
};

export default AddEditUser;
